import { useEffect, useState } from 'react';
import { fetchScene7Image } from '../fetch-data/fetch-bg-image';

export const useSceneSeven = (imageSrc: string, scene7extension?: string): string => {
  const [processedImageSrc, setProcessedImageSrc] = useState<string>('');

  useEffect(() => {
    const processScene7 = async () => {
      if (imageSrc) {
        try {
          const optimizedUrl = await fetchScene7Image(imageSrc, scene7extension);
          setProcessedImageSrc(optimizedUrl);
        } catch (error) {
          // Silent fallback
        }
      }
    };

    processScene7();
  }, [imageSrc, scene7extension]);

  return processedImageSrc;
};
